import { NoResults } from "client/Components";
import { localize } from "client_legacy/ndaw/culture";
import { ReactElement } from "react";

export const SearchNoResults = (): ReactElement => {
	return (
		<NoResults
			trackingId="has-no-results"
			icon="magnifying-glass"
			title={localize("_NoSearchResults")}
			message={localize("_PleaseTrySearchingWithAnotherTerm")}
			height="fill"
		/>
	);
};
SearchNoResults.displayName = "SearchNoResults";